module.exports = __webpack_public_path__ + "static/media/calzone.322c5872.svg";